module.exports = __webpack_public_path__ + "static/media/hongdanshan1.eca72899.webp";